<div class="modal-content">
	<div
		class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
	>
		<div class="modal-title">
			<h4 class="mb-0">Edit Disposition</h4>
		</div>
		<button
			type="button"
			class="close-btn"
			style="margin-left: auto"
			(click)="closeModalClick()"
		>
			<i class="fa-solid fa-xmark"></i>
		</button>
	</div>

	<div class="modal-body pb-4 mt-3">
		<form
			[formGroup]="edit_disposition_form"
			(ngSubmit)="editDispositionClick()"
		>
			<div class="required-legend mb-3">
				<span class="text-danger">*</span>
				<span class="text-light">Denotes a required field: {{ selected_dispo_type }}</span>
			</div>

			<div class="row align-items-center mb-3">
				<div class="col-sm-4"></div>
				<div class="col-sm-8 d-flex justify-content-start">
					<button
						type="button"
						class="btn modern-btn primary-btn px-4"
						(click)="changeDispoType()"
					>
						{{
							selected_dispo_type === dispositionTypes.individual
								? 'Dispose To FFL'
								: 'Dispose To Individual'
						}}
					</button>
				</div>
			</div>

			<div class="d-flex flex-column gap-3">
				@if (selected_dispo_type === dispositionTypes.ffl) {
					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_ffl"
						>
							<span class="text-danger">*</span> FFL:
						</label>
						<div class="col-sm-8 flex-grow-1 action-row">
							<input
								type="text"
								class="form-control modern-input text-uppercase"
								formControlName="d_ffl"
							/>
							<button
								type="button"
								class="btn modern-btn secondary-btn text-nowrap"
								(click)="fflSearchClick()"
							>
								Find FFL
							</button>
						</div>
					</div>

					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_disposed_to"
						>
							<span class="text-danger">*</span> Disposed To:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<input
								type="text"
								class="form-control modern-input text-uppercase w-100"
								formControlName="d_disposed_to"
							/>
						</div>
					</div>

					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_business_name"
						>
							Business Name:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<input
								type="text"
								class="form-control modern-input text-uppercase w-100"
								formControlName="d_business_name"
							/>
						</div>
					</div>
				}

				@if (selected_dispo_type === dispositionTypes.individual) {
					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_form4473_id"
						>
							<span class="text-danger">*</span> Form 4473 ID:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<input
								type="text"
								class="form-control modern-input text-uppercase w-100"
								formControlName="d_form4473_id"
							/>
						</div>
					</div>
				}

				@if (selected_dispo_type === dispositionTypes.individual) {
					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_first_name"
						>
							<span class="text-danger">*</span> First Name:
						</label>
						<div class="col-sm-8 flex-grow-1 action-row">
							<input
								type="text"
								class="form-control modern-input text-uppercase"
								formControlName="d_first_name"
							/>
							<button
								type="button"
								class="btn modern-btn secondary-btn"
								(click)="selectDriversLicenseClick()"
								title="Scan/Select ID"
							>
								<i class="fa-solid fa-address-card"></i>
							</button>
						</div>
					</div>

					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_middle_name"
						>
							Middle Name:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<input
								type="text"
								class="form-control modern-input text-uppercase w-100"
								formControlName="d_middle_name"
							/>
						</div>
					</div>

					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_last_name"
						>
							<span class="text-danger">*</span> Last Name:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<input
								type="text"
								class="form-control modern-input text-uppercase w-100"
								formControlName="d_last_name"
							/>
						</div>
					</div>

					<div class="row align-items-center">
						<label
							class="col-sm-4 col-form-label form-label text-end mb-0"
							for="d_sr_name"
						>
							Suffix:
						</label>
						<div class="col-sm-8 flex-grow-1">
							<ng-select
                                class="modern-input text-uppercase w-100"
                                [items]="suffixOptions"
                                [searchable]="false"
                                [clearable]="true"
                                placeholder="Select suffix"
                                formControlName="d_sr_name"
                            ></ng-select>
						</div>
					</div>
				}

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_address"
					>
						Address:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<input
							type="text"
							class="form-control modern-input text-uppercase w-100"
							formControlName="d_address"
						/>
					</div>
				</div>

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_address2"
					>
						Address 2:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<input
							type="text"
							class="form-control modern-input text-uppercase w-100"
							formControlName="d_address2"
						/>
					</div>
				</div>

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_zip_code"
					>
						Zip Code:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<input
							type="text"
							class="form-control modern-input text-uppercase w-100"
							formControlName="d_zip_code"
						/>
					</div>
				</div>

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_state"
					>
						State:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<ng-select
                            class="modern-input text-uppercase w-100"
                            [items]="states"
                            bindLabel="dropdown_label"
                            bindValue="state_name"
                            [searchable]="false"
                            [clearable]="true"
                            placeholder="Select state"
                            formControlName="d_state"
                        ></ng-select>
					</div>
				</div>

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_city"
					>
						City:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<input
							type="text"
							class="form-control modern-input text-uppercase w-100"
							formControlName="d_city"
						/>
					</div>
				</div>

				<div class="row align-items-center">
					<label
						class="col-sm-4 col-form-label form-label text-end mb-0"
						for="d_date_disposed"
					>
						<span class="text-danger">*</span> Date Disposed:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<input
							type="text"
							class="form-control modern-input text-uppercase w-100"
							formControlName="d_date_disposed"
							[bsConfig]="bsConfig"
							[(bsValue)]="today"
							bsDatepicker
						/>
					</div>
				</div>

				<div class="row align-items-start mt-3">
					<label
						for="edit_note"
						class="col-sm-4 col-form-label form-label text-end mb-0 pt-2"
					>
						<span class="text-danger">*</span>Edit Note:
					</label>
					<div class="col-sm-8 flex-grow-1">
						<textarea
							class="form-control modern-input w-100"
							formControlName="edit_note"
							id="edit_note"
							name="edit_note"
							style="min-height: 100px; resize: vertical"
							rows="4"
						></textarea>
					</div>
				</div>
			</div>

			<div class="d-flex justify-content-between mt-3 px-3">
				<button
					type="button"
					class="btn modern-btn secondary-btn px-4"
					(click)="closeModalClick()"
				>
					Cancel
				</button>
				<button
					type="submit"
					class="btn modern-btn primary-btn px-4"
					[disabled]="edit_disposition_form.invalid"
				>
					Edit Disposition
				</button>
			</div>
		</form>

		<div class="mt-4 ms-2">
			<span class="text-danger">*</span>
			<span class="text-light" style="font-size: 0.9rem"
				>denotes required fields</span
			>
		</div>
	</div>
</div>
